import {StateElectionDataEntry} from "./StateElectionDataEntry";

class USElectionData {
    get year(): number {
        return this._year;
    }

    private readonly _year: number;
    data: { [state: string]: StateElectionDataEntry } = {};

    constructor(year: number, preloadedData: any[]) {
        this._year = year;
        this.loadData(preloadedData);
    }

    private loadData(data: any[]): void {
        data.forEach((d: any) => {
            this.data[d.state] = {
                state_name: d.state,
                state_code: state_to_initials[d.state],
                total_votes: +d.total_votes,
                dem_votes: +d.dem_votes,
                dem_percentage: +d.dem_percentage,
                dem_electoral_votes: +d.dem_electoral_votes,
                rep_votes: +d.rep_votes,
                rep_percentage: +d.rep_percentage,
                rep_electoral_votes: +d.rep_electoral_votes,
                winner: d.winner,
                point_lead: +d.point_lead,
                num_voters_per_electoral_vote: +d.num_voters_per_electoral_vote
            };
        });
    }

    min(key: string): number | null {
        const values = Object.values(this.data)
            .map(electionData => electionData[key as keyof StateElectionDataEntry])
            .filter(value => typeof value === 'number') as number[];

        return values.length ? Math.min(...values) : null;
    }

    max(key: string): number | null {
        const values = Object.values(this.data)
            .map(electionData => electionData[key as keyof StateElectionDataEntry])
            .filter(value => typeof value === 'number') as number[];

        return values.length ? Math.max(...values) : null;
    }

    public getStateElectionData(state: string): StateElectionDataEntry {
        return this.data[state];
    }

    public static getStateInitials(state: string): string {
        //this method should also find the state initials for strings that are formatted like "NewHamphire"
        state = state.replace(/([a-z])([A-Z])/g, "$1 $2");

        if (!state_to_initials[state]) {
            throw new Error(`State not found: ${state}`);
        }
        return state_to_initials[state];
    }

    public getStateName(initials: string): string {
        for (let state in state_to_initials) {
            if (state_to_initials[state] === initials) {
                return state;
            }
        }
        throw new Error(`State not found: ${initials}`);
    }
}

//TODO: figure out why District of Columbia is not in the data
const state_to_initials: { [key: string]: string } = {
    "Alabama": "AL",
    "Alaska": "AK",
    "Arizona": "AZ",
    "Arkansas": "AR",
    "California": "CA",
    "Colorado": "CO",
    "Connecticut": "CT",
    "Delaware": "DE",
    "Florida": "FL",
    "Georgia": "GA",
    "Hawaii": "HI",
    "Idaho": "ID",
    "Illinois": "IL",
    "Indiana": "IN",
    "Iowa": "IA",
    "Kansas": "KS",
    "Kentucky": "KY",
    "Louisiana": "LA",
    "Maine": "ME",
    "Maryland": "MD",
    "Massachusetts": "MA",
    "Michigan": "MI",
    "Minnesota": "MN",
    "Mississippi": "MS",
    "Missouri": "MO",
    "Montana": "MT",
    "Nebraska": "NE",
    "Nevada": "NV",
    "New Hampshire": "NH",
    "New Jersey": "NJ",
    "New Mexico": "NM",
    "New York": "NY",
    "North Carolina": "NC",
    "North Dakota": "ND",
    "Ohio": "OH",
    "Oklahoma": "OK",
    "Oregon": "OR",
    "Pennsylvania": "PA",
    "Rhode Island": "RI",
    "South Carolina": "SC",
    "South Dakota": "SD",
    "Tennessee": "TN",
    "Texas": "TX",
    "Utah": "UT",
    "Vermont": "VT",
    "Virginia": "VA",
    "Washington": "WA",
    "West Virginia": "WV",
    "Wisconsin": "WI",
    "Wyoming": "WY"
}

export default USElectionData;